import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { update_page_meta } from "../../actions/page/header";
import PageHeader from "../../components/page/PageHeader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HomePageURL } from "../../assets/const";
import { listStoreVisits } from "../../actions/store/store";

const StoreVisit = ({ update_page_meta, listStoreVisits }) => {
    update_page_meta({
        title: "Store Visits",
        description: "Store visits made by Apogee employees"
    });
    let [searchParams, setSearchParams] = useSearchParams();
    const [Page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [numPages, setNumPages] = useState(0);
    const [count, setCount] = useState(0);
    const [Visits, setVisits] = useState([]);
    useEffect(() => {
        listStoreVisits(searchParams.has('store') ? searchParams.get('store') : "", Page, perPage).then(res => {
            if (res.success){
                setVisits(res.visits);
            }
        })
    }, [Page]);
    const rows = Visits?.map((visit, index) => {
        return (
            <tr key={index}>
                <td></td>
                <td>{visit?.store?.name} ({visit?.store?.store_code})</td>
                <td>{visit?.visited_by?.full_name}</td>
                <td>{visit?.created}</td>
                <td>{visit?.purpose}</td>
                <td>{visit?.comment}</td>
                <td>{visit?.mode_of_transportation}</td>
                <td>{visit?.distance}</td>
                <td>{visit?.amount}</td>
                <td>{visit?.food_expense}</td>
                {/* <td className="cursor-pointer" onClick={() => navigate(`${HomePageURL}/stores/${store?.slug}/`, {replace: false})}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </td> */}
            </tr>
        )
    })
    return (
        <>
            <PageHeader title="Store Visits" />
            <div className="row layout-top-spacing" id="cancel-row">
                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                    <div className="widget-content widget-content-area br-6">
                        <div className="table-responsive mb-4 mt-4">
                            <table id="zero-config" className="table table-hover" style={{width: "100%"}}>
                                <thead>
                                    <tr>
                                        <th className="no-content"></th>
                                        <th>Store</th>
                                        <th>Visited By</th>
                                        <th>Date &amp; Time</th>
                                        <th>Purpose</th>
                                        <th>Outcome</th>
                                        <th>Mode of Transportation</th>
                                        <th>Distance</th>
                                        <th>Amount</th>
                                        <th>Food Expenses</th>
                                        {/* <th className="no-content"></th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(null, { update_page_meta, listStoreVisits })(StoreVisit);